// In-memory admin token fallback for iframes that block third-party cookies.
let adminToken = null;

export const setAdminToken = (token) => { adminToken = token || null; };
export const adminHeaders = () => (adminToken ? { "X-Admin-Token": adminToken } : {});

export const apiError = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return fallback;
};
